// removed by extract-text-webpack-plugin
module.exports = {"Coconut":"#F4F7FA","container":"Gbb315d","layoutContainer":"G424ac5","pageContainer":"G618809"};